// extracted by mini-css-extract-plugin
module.exports = {"main":"LayoutStyles_main__3SAVk"};